import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';

import { BancoService } from '@app/services/banco.service';
import { Banco } from '@app/models/banco.model';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-banco-lista',
  templateUrl: './banco-lista.component.html'
})

export class BancoListaComponent implements OnInit {

  lstBanco: Banco[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao = '';
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private bancoService: BancoService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }


  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.bancoService.obterLista(descricao, pagina).toPromise().then(
      data => {
        this.lstBanco = data.Dados;
        this.paginacao.totalDeItens = data.Total;
      }, erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(banco: Banco) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir o banco: ' + banco.Nome + "?";
    this.bsModalRef.content.confirmar = () => {
      this.bancoService.deletar(banco.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
